import initialState from './federalBasicPermits.initialState';
import {
  LOAD_SUGGESTIONS_START,
  LOAD_SUGGESTIONS_SUCCESS,
  LOAD_SUGGESTIONS_ERROR,
  CLEAR_SUGGESTIONS,
} from './federalBasicPermits.actions';
import { applyByKey } from '../../utils/reducerHelpers';

export default function federalBasicPermitsReducer(state = initialState, action) {
  const { key } = action;

  switch (action.type) {
    case LOAD_SUGGESTIONS_START:
      return applyByKey(key, state, () => ({
        isLoadingSuggestions: true,
        suggestions: [],
        error: false
      }));
    case LOAD_SUGGESTIONS_ERROR:
      console.log(action);
      return applyByKey(key, state, () => ({
        isLoadingSuggestions: false,
        suggestions: [],
        error: true
      }));
    case LOAD_SUGGESTIONS_SUCCESS:
    {
      const { data } = action.response;
      return applyByKey(key, state, () => ({
        isLoadingSuggestions: false,
        suggestions: data,
        error: false
      }));
    }

    case CLEAR_SUGGESTIONS:
      return applyByKey(key, state, () => ({
        isLoadingSuggestions: false,
        suggestions: [],
        error: false
      }));

    default:
      return state;
  }
}
